import { useContext } from 'react';
import { ContextStore } from '../../contexts';

export const useContextStore = () => {
  const context = useContext(ContextStore);
  if (!context) {
    throw new Error('useContextStore must be used within a ContextProvider');
  }
  return context;
};
